import React from 'react';
import { Avatar, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  data as smsMode, WHATSUP, WHATSAPPBUSINESS, RINGOVER, RESPISMS, SMS, OCTOPUSH
} from '@lba-dev/package.local-globals/smsMode';

import loadImages from '../../utils/loadImages'
import LocalGlobalsIcon from '../../utils/localGlobalsIcons';

const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: 16,
    paddingBottom: 0
  },
  imageAvatar: {
    width: 18,
    height: 18,
    boxShadow: theme.shadows[1]
  },
  smsIcon: {
    border: '1px solid #000',
    color: '#000',
    borderRadius: 4,
    fontSize: 8,
  },
}));

const ModeIcon = ({ elemMode, isMailReceived = false }) => {
  const { classes } = useStyles();
  const mode = smsMode.find(e => e._id === +(elemMode || OCTOPUSH));
  const path = mode.image && loadImages(mode.image);

  return (mode && (![WHATSUP, WHATSAPPBUSINESS, RINGOVER, RESPISMS, SMS]
    .includes(mode._id) ?
    <Tooltip title={isMailReceived ? '' : mode.name}>
      <Typography
        children={isMailReceived ? 'Mail' : mode.display}
        variant='caption'
        className={classes.smsIcon}
        fontWeight={500}
      />
    </Tooltip> :
    (path &&
    <Tooltip title={mode.display}>
      <Avatar
        className={classes.imageAvatar}
        src={path}
        children={
          (mode.icon ? <LocalGlobalsIcon name={mode.icon}
            className={classes.icon} /> : '')
        }
      />
    </Tooltip>))) || '';
};

export default ModeIcon;
